import React from "react";
// UI Frameworks
import { TableCell } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
// Common Components
import { Button, FullScreenLoading, Modal, Loading } from "src/Components";
// Local Components
import AddEdit from "./AddEdit";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Requests
import { deleteUserGoldInstrumentTask } from "src/Requests/goldArbitrage";
// Types
import { UserGoldInstrumentTaskTableReport } from "src/Interfaces/goldArbitrage";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";

const AdditionalHeader = (_props: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">ویرایش</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">حذف</span>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: UserGoldInstrumentTaskTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const deleteHandler = () => {
    setLoading(true);
    deleteUserGoldInstrumentTask(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      <TableCell>
        {isEditModalOpen ? (
          <Modal
            title="ویرایش"
            UI={
              <AddEdit
                editValues={row}
                onClose={() => setIsEditModalOpen(false)}
                onSuccess={onAction}
              />
            }
            onClose={() => setIsEditModalOpen(false)}
            modalBoxClassName="!min-w-min !min-h-min"
          />
        ) : (
          <></>
        )}
        <div className="w-16 mx-auto" onClick={() => setIsEditModalOpen(true)}>
          <EditIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        <div onClick={deleteHandler}>
          {loading ? (
            <Loading size={16} className="!text-slate-700" />
          ) : (
            <DeleteIcon className="!text-red-700" />
          )}
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<UserGoldInstrumentTaskTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
